
(function ($) {
    $.fn.rlVideoYouTube = function () {

       var $players = $('.videoWrapper .youtubeapi');

        /**
         * OneTrust event triggers the rendering of YouTube players, depending on the users preferences.
         */
        $(window).on('OneTrustGroupsUpdated', function() {

            // if consent has been given, use the API player.
            if (typeof OnetrustActiveGroups !== undefined && OnetrustActiveGroups.split(',').indexOf('C0003') !== -1) {
                $(window).trigger('rl-video-youtube--allow-cookies');
                return;
            }

            // default to <iframe> cookie-less player.
            $(window).trigger('rl-video-youtube--no-cookies');
        });

        /**
         * YouTube IFrame Player API
         * https://developers.google.com/youtube/iframe_api_reference
         */
        $(window).on('rl-video-youtube--allow-cookies', function(){

            // load YouTube's script
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // YouTube's callback function to initialise each player.

            window['onYouTubeIframeAPIReady'] = function() {
                
                $players.each(function () {

                    var $playButton = $(this).parents().closest('.videoWrapper').find('.play');

                    var ytPlayer = new YT.Player(this.id, {
                        videoId: this.id,
                        height: '390',
                        width: '640',
                        events: {
                            'onReady': function () {
                                $playButton.on('click touch', function () {
                                   ytPlayer.playVideo();
                                });
                            },
                            'onStateChange': function () {
                                $playButton.addClass('hide');
                            }
                        },
                        playerVars: {
                            rel: 0,
                            color: 'white',
                            enablejsapi: 1,
                            showinfo: 0,
                            modestbranding: 0
                        },
                    });

                    $().rlVideoCommon();

                });
            }

           var YTiframes = document.querySelectorAll(".videoWrapper .youtubeapi");
           let ytCount = 0;
           YTiframes.forEach(function (f) {
              var YTaccordiona = document.querySelector("a[href='#transcript" + f.id + "']"),
                 YTaccordionb = document.querySelector("#transcript" + f.id),
                 newTransId = f.id + '-' + ytCount;

              if (YTaccordiona !== null) {
                 YTaccordiona.setAttribute('href', '#transcript' + newTransId);
                 YTaccordionb.setAttribute('id', 'transcript' + newTransId);
              }

              ytCount++;
           });

        });

        /**
         * YouTube's IFrame Player API does not support 'privacy enhanced' mode.
         * Instead of using the API, inject an <iframe> and remove the play button.
         * https://support.google.com/youtube/answer/171780?hl=en
         */
        $(window).on('rl-video-youtube--no-cookies', function(){
            $players.each(function () {
                //pass video block title to iframe title
                let videoTitle = $(this).attr('data-title');

                // inject iframe
                $(this).html('<iframe title="' + videoTitle + '" width="560" height="315" src="https://www.youtube-nocookie.com/embed/' + this.id + '" frameborder="0" allow="autoplay; encrypted-media;" allowfullscreen></iframe>');
                
                // remove play button
                $(this).parents().closest('.videoWrapper').find('.play').remove();
            });
        });
    }
}(jQuery)); 
